import { Landmark, Building2, Cable, TrendingUp, GraduationCap, MoreHorizontal } from "lucide-react";

export const PERSONAS = [
  { id: "council_member",      label: "Council Member",       blurb: "LA officer or elected member",            icon: Landmark },
  { id: "combined_authority",  label: "Combined Authority",   blurb: "Regional strategy & infrastructure",      icon: Building2 },
  { id: "operator",            label: "Operator / AltNet",    blurb: "ISP, FTTP rollout, network ops",          icon: Cable },
  { id: "investor",            label: "Investor",             blurb: "ESG / infrastructure capital",            icon: TrendingUp },
  { id: "researcher",          label: "Researcher",           blurb: "Academia, think tank, policy unit",       icon: GraduationCap },
  { id: "other",               label: "Other",                blurb: "Tell us later",                           icon: MoreHorizontal },
];

export default function PersonaPicker({ value, onChange, testid = "persona-picker" }) {
  return (
    <div data-testid={testid}>
      <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-[#5C5C59] mb-3">
        Who are you?
      </div>
      <div className="grid grid-cols-2 gap-2.5">
        {PERSONAS.map((p) => {
          const Icon = p.icon;
          const selected = value === p.id;
          return (
            <button
              key={p.id}
              type="button"
              onClick={() => onChange(p.id)}
              data-testid={`persona-${p.id}`}
              className={`text-left rounded-md border px-3.5 py-3 transition-all ${
                selected
                  ? "border-brand bg-brand text-white shadow-sm"
                  : "border-brand-border bg-white text-[#111110] hover:border-brand"
              }`}
            >
              <Icon className={`h-4 w-4 mb-2 ${selected ? "text-brand-accent" : "text-brand"}`} strokeWidth={1.5} />
              <div className="font-medium text-sm leading-tight">{p.label}</div>
              <div className={`text-[11px] leading-snug mt-0.5 ${selected ? "text-white/70" : "text-[#5C5C59]"}`}>
                {p.blurb}
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
}
